import { gql } from '@apollo/client';

export const GET_BUSINESS_NAVBAR = gql`
	query {
		businessServicesNavbar {
			id
			name
		}
	}
`;
